import Vue from 'vue';

import ViewListIcon from "vue-material-design-icons/ViewList";
import PencilIcon from "vue-material-design-icons/Pencil";
import TruckDeliveryIcon from "vue-material-design-icons/TruckDelivery";
import FileChartIcon from "vue-material-design-icons/FileChart"


Vue.component('ViewListIcon', ViewListIcon);
Vue.component('PencilIcon', PencilIcon);
Vue.component('TruckDeliveryIcon', TruckDeliveryIcon);
Vue.component('FileChartIcon', FileChartIcon);

export default [
  {
    'name': 'Main',
    'children': [
      {
        'name': 'Job',
        'children': [
          {
            icon: 'view-list',
            title: 'List Job',
            to: {
              name: 'job.list',
              query: {
                'limit': 10,
                'filter': 'not_delivered',
                'sort': 'requested_delivery_date',
                'order': 'asc'
              }
            },
            loggedIn: true,
          },
          {
            icon: 'truck-delivery',
            title: 'Job Allocation',
            to: {name: 'job.allocation', query: {}},
            loggedIn: true,
          },
          {
            icon: 'pencil',
            title: 'New Job',
            to: {name: 'job.create'},
            loggedIn: true
          },
          {
            icon: 'file-chart',
            title: 'Reports',
            to: {name: 'reports', params: {reportName: "NONE"}},
            loggedIn: true,
          }
        ],
        loggedIn: true,
      },
      {
        'name': 'Customer',
        'children': [
          {
            icon: 'view-list',
            title: 'List Customer',
            to: {name: 'customer.list', query: {'limit': 10, 'filter': 'active'}},
            loggedIn: true,
          },
          {
            icon: 'pencil',
            title: 'New Customer',
            to: {name: 'customer.create'},
            loggedIn: true
          },
        ],
        loggedIn: true,
      },
      {
        'name': 'Pre-Start Check List',
        'children': [
          {
            icon: 'view-list',
            title: 'List Pre-Start Check List',
            to: {name: 'pre_start_check_list.list', query: {'limit': 10, 'filter': 'active'}},
            loggedIn: true,
          },
          {
            icon: 'pencil',
            title: 'New Pre-Start Check List',
            to: {name: 'pre_start_check_list.create'},
            loggedIn: true
          },
        ],
        loggedIn: true,
      },
      {
        'name': 'Truck',
        'children': [
          {
            icon: 'view-list',
            title: 'List Truck',
            to: {name: 'code_truck.list', query: {'limit': 10, 'filter': 'active'}},
            loggedIn: true,
          },
          {
            icon: 'pencil',
            title: 'New Truck',
            to: {name: 'code_truck.create'},
            loggedIn: true
          },
        ],
        loggedIn: true,
      }]
  },
  {
    'name': 'Admin',
    'children': [
      {
        'name': 'Manage',
        'children': [
          {
            icon: 'view-list',
            title: 'List On Site Contact',
            to: {name: 'on_site_contact.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List Product',
            to: {name: 'code_product.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List File Type',
            to: {name: 'code_file_type.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List Area',
            to: {name: 'code_area.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List Time Of Day',
            to: {name: 'code_time_of_day.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
        ],
        loggedIn: true,
      },
      {
        'name': 'Users & Roles',
        'children': [
          {
            icon: 'view-list',
            title: 'List Users',
            to: {name: 'user.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List Groups',
            to: {name: 'group.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },
          {
            icon: 'view-list',
            title: 'List Group Permissions',
            to: {name: 'group_permissions.list', query: {'limit': 10, 'filter': 'all'}},
            loggedIn: true,
          },

        ],
        loggedIn: true
      }]
  }
];